import Keycloak from 'keycloak-js';
const keycloak = new Keycloak({
 url      : window.KEYCLOAK_URL,
 realm    : window.KEYCLOAK_REALM,
 clientId : window.KEYCLOAK_CLIENT_ID,
});

export default keycloak;